// message-refresh.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoRefreshService {

  private _refreshRequired = new Subject<void>();
  refreshRequired$ = this._refreshRequired.asObservable();

  triggerRefresh() {
    this._refreshRequired.next();
  }
}
